import React, { useContext } from 'react';

import { Paper, styled, Link, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, useMediaQuery, useTheme, tableCellClasses } from '@mui/material';

import GamesContext from '../../store/games-context';
import { INITIAL_SPLIT_INDEX } from '../../utils/constants';
import Run from '../../types/run';
import Split from '../../types/split';

import style from './result.module.css';
import { sortByOrder } from '../../utils/utils';

const ClipItem = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  textAlign: 'center'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Result = ({ selectedGame, includesHit, splitHit, clip, startSplit = 0, endSplit }: Run) => {
  const gamesContext = useContext(GamesContext);
  const games = gamesContext.games;

  const selectedGameObject = games[selectedGame];
  const finalSplitIndex = INITIAL_SPLIT_INDEX + (selectedGameObject.splits.length);
  const resultStartSplit = startSplit === undefined ? INITIAL_SPLIT_INDEX : startSplit;
  const resultEndSplit = endSplit === undefined ? (finalSplitIndex + 1) : endSplit;
  const renderSplits = () => {
    const splitsOrdered = selectedGameObject.splits.sort(sortByOrder);
    let splitHitObject : Split = {} as Split;
    let splitHitOrder : number;
    if(splitHit !== undefined && splitHit >= 0) {
      splitHitObject = splitsOrdered.find(split => split.id === splitHit) as Split;
      splitHitOrder = splitHitObject.order;
    }
    return (splitsOrdered?.map(split => {
      let className : string = '';
      
      if (includesHit) {
        if (split.order < splitHitOrder && split.id >= resultStartSplit && split.id <= resultEndSplit) {
          className = 'success';
        } else if (split.order === splitHitOrder) {
          className = 'hit';
        }
      } else {
        if (split.id >= resultStartSplit && split.id < resultEndSplit) {
          className = 'success';
        }
      }
      return (
        <StyledTableRow className={style.row}>
          <TableCell>
            <div className={`${style.itemContent} ${style[className]}`}>
              {split.name}
            </div>
          </TableCell>
        </StyledTableRow>
      );
    }));
  };

  const renderClip = (gameClassName: string) => {
    if (clip) {
      return (<Link href={clip} target={'_blank'} rel={'noreferrer'} className={style[gameClassName]}>Clip</Link>);
    }
    return '-';
  }

  const renderGame = () => {
    const isParcial = resultEndSplit < finalSplitIndex;
    const gameClassName = includesHit ? 'fail' : !isParcial ? 'success' : '';
    return (
      <TableContainer className={`${style.run} ${style.column}`} sx={{ minWidth: 190, margin: '5px' }} component={Paper} >
        <Table sx={{ width: 180 }} size='small'>
          <TableHead sx={{ textAlign: 'center' }}>
            <StyledTableCell className={`${style.itemContent} ${style.headerItem} ${style[gameClassName]}`}>{selectedGameObject?.name}</StyledTableCell>
          </TableHead>
          <TableBody>
          {renderSplits()}
          <TableRow>
            <ClipItem className={`${style.itemContent} ${style.clip}`}>{renderClip(gameClassName)}</ClipItem>
          </TableRow>
          </TableBody>
          {/* <Divider sx={{ backgroundColor: 'white', marginTop: '12px', marginLeft: '8px', display: { xs: 'block', md: 'none' }, mr: 1 }}/> */}
        </Table>
      </TableContainer>
    )
  }

  return renderGame();
};

export default Result;
